<template>
  <div id="dailyOrderPrinting-print" class="page-break">
    <el-row>
      <el-col :span="24">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000" >
          {{ this.printProject }}日订单
        </h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:50px;">
      <el-col v-if="topData.length > 0" :span="9">
        <ul>
          <li >
            供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{ topData[0].SUPPLIER_NAME }}
          </li>
          <li>项&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ topData[0].PROJECT_NAME }}</li>
          <!-- 当不打印实收的时候 总金额就是 订购数量*金额 = TOTAL_PROJECT_FEE ⬇-->
          <li v-if="topData[0].SHOW_PRICE == 1">
            订购总金额：{{ topData[0].TOTAL_PROJECT_FEE }}</li>
        </ul>
      </el-col>
      <el-col :span="12" style="padding-left: 70px">
        <ul>
          <li >制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
          <!-- 当打印实收的时候 总金额就是 实收*金额 = REAL_TOTAL_PROJECT_FEE ⬇-->
          <li v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 1">
            实收总金额：{{ topData[0].REAL_TOTAL_PROJECT_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th style="width: 7%">编码</th>
            <th style="width: 10%">名称</th>
            <th style="width: 3%">单位</th>
            <th style="width: 5%">订购</th>
            <th style="width: 5%">实收</th>
            <!-- 价格及总金额只有打印价格的时候才显示 -->
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 5%">价格</th>
            <th v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 1" style="width: 6%">总金额</th>
<!--            打印实收 就是 实收*价格-->
            <th v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 0" style="width: 6%">总金额</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.INNER_CODE }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <td v-if="printRealFlag == 1">{{ item.REAL_COUNT }}</td>
            <td v-if="printRealFlag == 0"></td>
            <!-- 价格及总金额只有打印价格的时候才显示 -->
            <td v-if="topData[0].SHOW_PRICE == 1">{{ item.PROJECT_PRICE }}
            </td>
            <!-- 订购数量打印且打实收则显示订购总金额 -->
            <td v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 1">
              {{ Math.round((item.REAL_COUNT * item.PROJECT_PRICE) * 100) / 100  }}
            </td>
            <!-- 送货数量打印且不打实收则显示送货总金额 -->
            <td v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 0">
              {{ Math.round((item.PRODUCT_COUNT * item.PROJECT_PRICE) * 100) / 100 }}
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="6">
        <span>收货时间：</span>
      </el-col>
      <el-col :span="6">
        <span v-if="(topData[0].SHOW_PRICE == 1)">本页金额：{{ mainData[0].pageFee }}</span>
      </el-col>
<!--      <el-col :span="6">-->
<!--        <span v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 0">订单总金额：{{ project_total_fee }}</span>-->
<!--      </el-col>-->
<!--      <el-col :span="6">-->
<!--        <span v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 1">订单总金额：{{ tatal_project_real_fee }}</span>-->
<!--      </el-col>-->
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>送货员：</span>
      </el-col>
      <el-col :span="6">
        <span>项目经理：</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="21" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    project: String,
    PROJECT_TOTAL_FEE: Number,
    TOTAL_PROJECT_REAL_FEE: Number,
  },
  data() {
    return {
      managername: '',
      topData: [],
      mainData: [],
      supplier_name: '',
      printProject: '',
      PRINT_PROJECT_NAME: '',
      printRealFlag: Number(sessionStorage.getItem('PRINT_REAL_COUNT')), // 实收 0 不带 1 带
      project_total_fee: 0,
      tatal_project_real_fee: 0,
    };
  },
  created() {
    this.topData = this.headerData;
    this.supplier_name = this.headerData[0].SUPPLIER_NAME;
    this.mainData.push(this.tableData);
    this.printProject = this.project;
    this.project_total_fee = this.PROJECT_TOTAL_FEE ? this.PROJECT_TOTAL_FEE.toFixed(2) : 0;
    this.tatal_project_real_fee = this.TOTAL_PROJECT_REAL_FEE ? this.TOTAL_PROJECT_REAL_FEE.toFixed(2) : 0;
    this.managername = this.manager;
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 24px;
  font-family: 黑体;
  color: #000;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/dailyOrderPrintTax.vue